import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class StockRequestHistorySliderModelService {
  public addStockTransferRequestHistorySlider: BehaviorSubject<boolean>;
  public stockTransferAddSidenav: MatSidenav;
  private activeSliderValue: string;
  stockTransferSliderCloseRqt: Subject<boolean>;
  stockTransferAddModelData: BehaviorSubject<any>;
  public newItems: any;
  public sotRequestId: number;

  constructor() {
    this.addStockTransferRequestHistorySlider = new BehaviorSubject(false);
    this.stockTransferAddModelData = new BehaviorSubject(EMPTY);
    this.stockTransferSliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'SOTRequestHistorySlider') {
      this.addStockTransferRequestHistorySlider.next(true);
      this.stockTransferAddModelData.next(EMPTY);
      this.stockTransferAddSidenav.toggle();
    }
  }

  public setStockTransferSideNav(requestHistorySideNavObj: MatSidenav) {
    this.stockTransferAddSidenav = requestHistorySideNavObj;
  }

  public stockTransferClose() {
    this.stockTransferAddModelData.next(EMPTY);
    this.addStockTransferRequestHistorySlider.next(false);
    this.stockTransferAddSidenav.close();
  }

  public setData<T>(obj: T) {
    this.stockTransferAddModelData.next(obj);
  }

  public getNewItem() {
    return this.newItems;
  }

  public setNewItem(newItems) {
    this.newItems = [];
    this.newItems = newItems;
  }
}
